import React from "react";
import { useTranslation } from "react-i18next";
import { WR } from "../../../components/ui/tokens";

const button = (variant) => ({
  border: 0,
  borderRadius: 999,
  padding: "10px 16px",
  fontSize: 13,
  fontWeight: 700,
  fontFamily: WR.font.sans,
  cursor: "pointer",
  whiteSpace: "nowrap",
  background:
    variant === "primary" ? WR.color.brand : variant === "danger" ? WR.color.errorBg : WR.color.lavSoft,
  color: variant === "primary" ? "#fff" : variant === "danger" ? WR.color.error : WR.color.brand,
});

// Sticky toolbar shown above the grid while a subcategory is being rearranged.
const LayoutEditBar = ({ saving, error, onValidate, onCancel, onReset }) => {
  const { t } = useTranslation();
  return (
    <div
      role="toolbar"
      aria-label={t("LAYOUT_EDIT")}
      style={{
        position: "sticky",
        top: 0,
        zIndex: 5,
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 10,
        padding: "12px 16px",
        marginBottom: 14,
        background: WR.color.surface,
        border: `1px solid ${WR.color.border}`,
        borderRadius: WR.radius.card,
        boxShadow: WR.shadow.card,
        fontFamily: WR.font.sans,
      }}
    >
      <span style={{ flex: 1, minWidth: 200, fontSize: 13, color: WR.color.inkMuted }}>
        {t("LAYOUT_EDIT_HINT")}
      </span>
      <button type="button" style={{ ...button("danger"), opacity: saving ? 0.6 : 1 }} disabled={saving} onClick={onReset}>
        {t("LAYOUT_RESET")}
      </button>
      <button type="button" style={{ ...button("secondary"), opacity: saving ? 0.6 : 1 }} disabled={saving} onClick={onCancel}>
        {t("LAYOUT_CANCEL")}
      </button>
      <button type="button" style={{ ...button("primary"), opacity: saving ? 0.6 : 1 }} disabled={saving} onClick={onValidate}>
        {t("LAYOUT_VALIDATE")}
      </button>
      {error && (
        <div role="alert" style={{ width: "100%", fontSize: 13, color: WR.color.error }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default LayoutEditBar;
